import React from "react";
import styles from "./contactUs.module.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/footer/footer";
import locationImage from "../../assets/images/contactUs/location.svg";
import phoneNumberImage from "../../assets/images/contactUs/phoneNumber.svg";
import emailImage from "../../assets/images/contactUs/email.svg";
import googleMapImage from "../../assets/images/contactUs/googleMap.svg";
import LazyLoad from "react-lazyload";

const ContactUs = () => {
  return (
    <div>
      {" "}
      <NavBar />
      <LazyLoad offset={100} once>
        <div className={styles.container}>
          <div className={styles.overlay}>
            <div className={styles.contactBox}>
              <div className={styles.containerHeader}>
                <h2 className={styles.header}>Contact us</h2>
                <div className={styles.dropdown}>
                  <button className={styles.dropbtn}>Headquarters</button>
                </div>
              </div>

              <div className={styles.contactDetails}>
                <p>
                  <div>
                    <img src={locationImage} alt="-" className={styles.icon} />
                  </div>
                  <div className={styles.containerDetails}>
                    <span>Location</span>
                    <span style={{ maxWidth: "223px" }}>
                      {" "}
                      7 Lazoghli street, Garden City, Cairo, Egypt
                    </span>
                  </div>{" "}
                </p>
                <p>
                  <img src={phoneNumberImage} alt="-" className={styles.icon} />
                  <div className={styles.containerDetails}>
                    <span>Phone Number</span>
                    <span>+20227924281</span>
                  </div>
                </p>
                <p>
                  <img src={emailImage} alt="-" className={styles.icon} />
                  <div className={styles.containerDetails}>
                    <span>Email</span>
                    <span> info@cf-holding.com</span>
                  </div>
                </p>
                <p>
                  <img src={googleMapImage} alt="-" className={styles.icon} />{" "}
                  <div className={styles.containerDetails}>
                    Google Map
                    <a
                      href="https://maps.app.goo.gl/19AXqUXKzou7Le2r6?g_st=com.google.maps.preview.copy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Company Headquarters Location
                    </a>
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <Footer />
    </div>
  );
};

export default ContactUs;
